/**
 * Maps the numeric `subcontractor` field from the session API to user type constants.
 * Source: SUBCONTRACTOR_TYPE_MAP in userManagement.constants.ts
 */
export const SUBCONTRACTOR_TYPE = {
  NORMAL: 0,
  COMPANY: 1,
  FUNDING_SOURCE: 2,
  CLIENT_POOL: 3,
  ECOLANE: 4,
} as const;

export type SubcontractorType = (typeof SUBCONTRACTOR_TYPE)[keyof typeof SUBCONTRACTOR_TYPE];

export interface User {
  id: string;
  email: string;
  name: string;
  roles: string[];
  permissions: string[];
  tenantId: string;
  userType: string;
  login?: string;
  subcontractor?: number;
  companyIds?: number[];
  fundingSourceIds?: number[];
  centerId?: number | null;
  defaultRunPoolId?: number | null;
  accessUnassignedNoRunTrips?: boolean;
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
}
// Common roles across the system
export const USER_ROLES = {
  ADMIN: "admin",
  DISPATCHER: "dispatcher",
  DRIVER: "driver",
  SCHEDULER: "scheduler",
  VIEWER: "viewer",
  SUPERVISOR: "supervisor",
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];
